var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrowIconBoldDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21370_30598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 16.9999V19.4999C22 20.8784 20.8785 21.9999 19.5 21.9999H4.5C3.1215 21.9999 2 20.8784 2 19.4999V16.9999H0V19.4999C0 21.9814 2.019 23.9999 4.5 23.9999H19.5C21.981 23.9999 24 21.9814 24 19.4999V16.9999H22Z",
    fill: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3.91394V18.9999H13V3.91394L18.793 9.70694L20.207 8.29294L12 0.0859375L3.793 8.29294L5.207 9.70694L11 3.91394Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21370_30598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrowIconBoldDisabled);
export default __webpack_public_path__ + "static/media/upload_arrow_icon_bold_disabled.bc5ad14a8f90b1c0fa466a4e8893a9aa.svg";
export { ForwardRef as ReactComponent };